export function jqueryExtend() {
  const frames = document.getElementById('viewer').getElementsByTagName('iframe');
  for (let frame of frames) {
    if (frame.contentWindow.$ !== 'undefined') {
      const jq = frame.contentWindow.$;
      if (typeof jq === 'undefined') {
        return;
      }

      setScriptOverride(jq);
    }
  }
}

function setScriptOverride(jq) {
  jq.getScript = function (url, callback, options) {
    // Allow user to set any option except for dataType, cache, and url
    // eslint-disable-next-line no-param-reassign
    options = jq.extend(options || {}, {
      dataType: 'script',
      crossDomain: true,
      url,
      success: callback,
      cache: true, // to avoid jquery adding a query param with the purpose of not caching
    });

    // Use $.ajax() since it is more flexible than $.getScript
    // Return the jqXHR object so we can chain callbacks
    return jq.ajax(options);
  };
}
